export type ChatUiLanguage = 'en' | 'es' | 'pt';

type LeadFormCopy = {
  title: string;
  defaultReason: string;
  conversionReason: string;
  requestLabel: string;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  notNow: string;
  send: string;
  sending: string;
};

const LEAD_FORM_COPY: Record<ChatUiLanguage, LeadFormCopy> = {
  en: {
    title: 'Stay in touch',
    defaultReason: 'Share your name and work email so our team can follow up.',
    conversionReason: 'Share your details so Alio can help with your request.',
    requestLabel: 'Your request (sent with this form)',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Work email',
    company: 'Company (optional)',
    notNow: 'Not now',
    send: 'Send to team',
    sending: 'Sending…',
  },
  es: {
    title: 'Mantengamos el contacto',
    defaultReason: 'Comparte tu nombre y correo de trabajo para que el equipo pueda dar seguimiento.',
    conversionReason: 'Comparte tus datos para que Alio pueda ayudarte con tu solicitud.',
    requestLabel: 'Tu solicitud (se envía con este formulario)',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo de trabajo',
    company: 'Empresa (opcional)',
    notNow: 'Ahora no',
    send: 'Enviar al equipo',
    sending: 'Enviando…',
  },
  pt: {
    title: 'Vamos manter contato',
    defaultReason: 'Compartilhe seu nome e e-mail corporativo para nossa equipe acompanhar.',
    conversionReason: 'Compartilhe seus dados para a Alio ajudar com sua solicitação.',
    requestLabel: 'Sua solicitação (enviada com este formulário)',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail corporativo',
    company: 'Empresa (opcional)',
    notNow: 'Agora não',
    send: 'Enviar para a equipe',
    sending: 'Enviando…',
  },
};

export function getChatLeadFormCopy(lang?: string | null): LeadFormCopy {
  const code = String(lang || 'en').toLowerCase().slice(0, 2) as ChatUiLanguage;
  return LEAD_FORM_COPY[code] || LEAD_FORM_COPY.en;
}
